import React from "react"

const Tooltip = ({ children, text, showArrow = false }) => {
  return (
    <div className="relative inline-block items-center group">
      {children}

      <div className="absolute rounded-lg bottom-full left-1/2 mb-4 -translate-x-1/2 whitespace-nowrap min-w-[160px] rounded bg-white border border-gray-300 px-7 py-7 text-base text-gray-800 shadow-xl opacity-0 invisible transition-all duration-200 group-hover:visible group-hover:opacity-100 z-10">
        {text}
        {showArrow && (
          <span className="absolute left-1/2 top-full -translate-x-1/2 w-0 h-0 border-l-8 border-r-8 border-t-8 border-l-transparent border-r-transparent border-t-white"></span>
        )}
      </div>
    </div>
  )
}

export default Tooltip
